import { OfferType } from "../Utils/constant";

const intialOrderState = {
  roundOff: 0,
  subTotal: 0,
  total: 0,
  totalOfferApplied: 0,
  offerDenom: OfferType.No_Offer,
  offerAmt: 0,
  cgstAmt: 0,
  sgstAmt: 0,
  totalBeforeOffer: 0, //means before coupon, total
  isGstAllowed: true,
  coupon: "",
  totalQuantity: 0,
  deliveryCharge: 0,
};
const OrderReducer = (state, action) => {
  switch (action.type) {
    case "setOrderDetails":
      return {
        ...(state || intialOrderState),
        ...action.payload,
      };

    case "setDesAddress":
      return { ...state, destinationAddress: action.payload };

    case "setCouponData":
      return {
        ...state, coupon: action.payload.coupon,
        offerAmt: action.payload.offerAmt, offerDenom: action.payload.offerDenom,
        totalOfferApplied: action.payload.totalOfferApplied,
        total: action.payload.total,
      };

    case "setOrderReset":
      return intialOrderState;

    default:
      return state;
  }
};
export { intialOrderState, OrderReducer };
